import { useInjection } from "@linkfluence/core/di";
import { Locale } from "@linkfluence/models/locale";
import { useQuery } from "@tanstack/react-query";
import { tr } from "@radarly/i18n";
import { FocusMetrics } from "@radarly/models/aicha";
import { BaseSearchParams } from "@radarly/models/search";
import { AichaRepo, AichaRepositoryUID } from "../repositories/AichaRepo";
import {
  ERROR_CODE_TOO_FEW_POSTS,
  PostlistSummaryError,
  formatSummary,
  getPostlistSummaryRequest,
} from "./utils";

export function usePostlistSummary(
  pid: number,
  _request: BaseSearchParams,
  focusMetrics: FocusMetrics[]
) {
  const repository = useInjection<AichaRepo>(AichaRepositoryUID);
  const request = getPostlistSummaryRequest(_request);

  const { data, isLoading, isError, error } = useQuery<
    { data: string },
    PostlistSummaryError
  >(
    ["/aicha/postlist-summary", { pid, request }],
    () => {
      return repository.getPostlistSummary(pid, request, focusMetrics);
    },
    {
      enabled: !!request,
      retry: 1, // Prevent retries when we get a "Not enough posts" error
      staleTime: 60 * 1000,
    }
  );

  const summary = isLoading
    ? null
    : isError && error?.error?.code === ERROR_CODE_TOO_FEW_POSTS
    ? tr(Locale.English, "DISCOVERY::AICHA::NOT_ENOUGH_POSTS_ERROR_PLACEHOLDER")
    : isError || data === null
    ? tr(Locale.English, "DISCOVERY::AICHA::DATA_ERROR_PLACEHOLDER")
    : formatSummary(data.data);

  return {
    isLoading,
    summary,
  };
}
